export const parseDateValue = (val) => {
  if (val === null || val === undefined || val === "") return 0;
  const ts = Date.parse(val);
  return isNaN(ts) ? 0 : ts;
};